import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Back from "../../components/button/back";

function HalamanBerita() {
  const { id } = useParams();
  const [berita, setBerita] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBerita = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}api/berita/${id}`,
        );
        const data = await res.json();
        setBerita(data);
      } catch (err) {
        console.error("Gagal mengambil berita:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBerita();
  }, [id]);

  const formatTanggal = (tanggal) => {
    const date = new Date(tanggal);
    const bulan = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Okt",
      "Nov",
      "Des",
    ];
    return `${date.getDate()} ${bulan[date.getMonth()]} ${date.getFullYear()}`;
  };

  const renderMedia = () => {
    if (!berita?.gambar?.length) return null;

    return berita.gambar.map((item, index) => {
      const src = `${process.env.REACT_APP_API_URL}api/berita/media/${item.filename}`;

      if (item.mimetype?.startsWith("video/")) {
        return (
          <video
            key={index}
            controls
            className="w-full aspect-video object-cover rounded-lg mb-4"
            src={src}
          />
        );
      }

      if (item.mimetype?.startsWith("image/")) {
        return (
          <img
            key={index}
            src={src}
            alt={berita.judul}
            className="w-full object-cover rounded-lg mb-4"
          />
        );
      }

      return null;
    });
  };

  const renderLinks = () => {
    if (!berita?.link?.length) return null;

    return berita.link.map((url, index) => {
      let embedUrl = url;

      if (url.includes("youtube.com/watch?v=")) {
        const id = url.split("v=")[1]?.split("&")[0];
        embedUrl = `https://www.youtube.com/embed/${id}`;
      } else if (url.includes("youtu.be/")) {
        const id = url.split("youtu.be/")[1]?.split("?")[0];
        embedUrl = `https://www.youtube.com/embed/${id}`;
      } else if (url.includes("drive.google.com")) {
        const id = url.match(/[-\w]{25,}/)?.[0];
        embedUrl = `https://drive.google.com/file/d/${id}/preview`;
      }

      return (
        <iframe
          key={index}
          src={embedUrl}
          title={`media-${index}`}
          className="w-full aspect-video rounded-lg mb-4"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      );
    });
  };

  if (loading) {
    return <p className="text-center mt-10 text-gray-500">Memuat berita...</p>;
  }

  if (!berita) {
    return (
      <p className="text-center mt-10 text-red-500">Berita tidak ditemukan</p>
    );
  }

  return (
    <div className="max-w-5xl mx-auto p-6 text-gray-800">
      <Link to="/">
        <Back />
      </Link>

      <div className="bg-white shadow-md rounded-lg p-6 mt-4">
        <h1 className="text-2xl font-bold text-center mb-2">{berita.judul}</h1>

        <p className="text-center text-sm text-gray-500 mb-6">
          {formatTanggal(berita.tanggal)}
        </p>

        {/* MEDIA */}
        {renderMedia()}

        {/* LINK */}
        {renderLinks()}

        <p className="text-lg mt-4 leading-relaxed text-gray-700">
          {berita.deskripsi}
        </p>

        <p className="text-xs text-gray-500 mt-6">
          <strong>Penulis:</strong> {berita.penulis || "Admin"}
        </p>
      </div>
    </div>
  );
}

export default HalamanBerita;
